export default "/fonts/Acrom.ttf?370490370b7848d3228136be5287ead1";